import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-rhombus', 'IconArrowUpRhombus', [
  ['path', { d: 'M12 16v-13', key: 'svg-0' }],
  ['path', { d: 'M15 6l-3 -3l-3 3', key: 'svg-1' }],
  ['path', { d: 'M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z', key: 'svg-2' }],
]);
